import React from "react";
import { Phone, Mail } from "lucide-react";

export default function About() {
    return (
        <div className="bg-background">
            <section className="border-b border-black/10">
                <div className="container-edge py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-7">
                        <p className="overline">About</p>
                        <h1 className="mt-3 font-heading font-black text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
                            Faculty-first AI training,<br />built by people who actually teach.
                        </h1>
                        <p className="mt-6 max-w-xl text-lg text-muted-foreground leading-relaxed">
                            ai4faculty exists because most AI training is built for tech bros. Faculty deserve better:
                            programs that respect their time, their disciplines, and their commitment to academic integrity.
                        </p>
                    </div>
                    <div className="lg:col-span-5">
                        <div className="border border-black/15 p-8 bg-secondary">
                            <p className="overline">What we believe</p>
                            <ul className="mt-4 space-y-4 text-sm">
                                <li>– AI should make great teachers more effective, not replace them.</li>
                                <li>– Real examples beat theory.</li>
                                <li>– Templates and policies you can ship today.</li>
                                <li>– Workshops belong on your campus, with your team.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-secondary">
                <div className="container-edge py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
                    <div>
                        <p className="overline">Contact</p>
                        <h2 className="mt-3 font-heading font-bold text-2xl tracking-tight">Talk to us</h2>
                    </div>
                    <a href="tel:8135281102" className="flex flex-col gap-2 hover:text-klein" data-testid="about-phone">
                        <Phone className="text-klein" size={20} />
                        <span className="text-xs uppercase tracking-widest text-muted-foreground">Phone</span>
                        <span className="font-heading text-2xl font-bold">813-528-1102</span>
                    </a>
                    <a href="mailto:gdobson@degreesofsuccessinfo.com" className="flex flex-col gap-2 hover:text-klein" data-testid="about-email">
                        <Mail className="text-klein" size={20} />
                        <span className="text-xs uppercase tracking-widest text-muted-foreground">Email</span>
                        <span className="font-heading text-lg font-bold break-all">gdobson@degreesofsuccessinfo.com</span>
                    </a>
                </div>
            </section>
        </div>
    );
}
